import styled, { css } from 'styled-components';

// One spec for the small icon controls that sit in tab bars (chat "+", chat
// history, DS section "+"). Two flavors: a real button, and a div for nesting
// inside Radix triggers, which render a button of their own.
const barIconButton = css`
	background: transparent;
	border: none;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 26px;
	height: 26px;
	border-radius: 6px;
	outline: none;
	flex-shrink: 0;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}

	&:focus-visible {
		outline: none;
		box-shadow: 0 0 0 2px ${({ theme }) => theme.blue[500]};
	}
`;

export const BarIconButton = styled.button`
	${barIconButton}

	&:disabled {
		opacity: 0.5;
	}
`;

export const BarIconTrigger = styled.div`
	${barIconButton}
`;
